/** Spec §14.2 page 10: household settings and audit log. Viewer role is read-only. */
import { useAuditLog, useHealth } from "../api/hooks.js";
import { PageState } from "../components/PageState.js";

export function SettingsPage({ role }: { role: string }) {
  const audit = useAuditLog();
  const health = useHealth();
  const canEdit = role === "admin";

  return (
    <PageState query={{ isPending: audit.isPending, error: audit.error }}>
      {!canEdit ? <p className="notice">Viewer role: settings are shown read-only.</p> : null}
      <div className="grid">
        <div className="card"><h3>Timezone</h3><div className="value">America/New_York</div><div className="hint">household default from server config</div></div>
        <div className="card"><h3>Audio capture</h3><div className="value">{health.data?.audio_capture_enabled ? "ON" : "OFF"}</div></div>
        <div className="card"><h3>Audit rows</h3><div className="value">{(audit.data ?? []).length}</div></div>
      </div>
      {(audit.data ?? []).length === 0 ? (
        <p className="notice">No audit entries recorded.</p>
      ) : (
        <table>
          <thead><tr><th>When</th><th>Actor</th><th>Action</th><th>Target</th><th>Outcome</th></tr></thead>
          <tbody>
            {(audit.data ?? []).map((a) => (
              <tr key={a.id}>
                <td>{new Date(a.timestamp).toLocaleString()}</td>
                <td className="mono">{a.actor.slice(0, 8)}…</td>
                <td>{a.action}</td>
                <td className="mono">{a.target.slice(0, 12)}</td>
                <td>{a.outcome}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <p className="muted">
        Model endpoints, retention windows, quotas and MFA enrollment are configured on the server; the dashboard
        surfaces them so nothing here pretends to be editable when it is not.
      </p>
    </PageState>
  );
}
